/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Polyline, Line, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Sword(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Polyline
        points="72.201 128.201 152.201 40.201 216 40 215.799 103.799 127.799 183.799"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Line
        x1={100}
        y1={156}
        x2={160}
        y2={96}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M82.14214,205.45584,60.201,227.397a8,8,0,0,1-11.31371,0L28.603,207.11268a8,8,0,0,1,0-11.31371l21.94113-21.94112a8,8,0,0,0,0-11.31371L33.65685,145.65685a8,8,0,0,1,0-11.3137l16.6863-16.6863a8,8,0,0,1,11.3137,0l76.6863,76.6863a8,8,0,0,1,0,11.3137l-16.6863,16.6863a8,8,0,0,1-11.3137,0L93.45584,205.45584A8,8,0,0,0,82.14214,205.45584Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default Sword;
